import {
  ListItem,
  ListItemButton,
  ListItemIcon,
  List,
  ListItemText,
  Collapse,
} from "@mui/material";
import { useState, useEffect } from "react";
import { useAppSelector } from "../../store/store";
import SidebarItem from "./SidebarItem";

type Props = {
  item: any;
  index: any;
  open: any;
  handleDrawerSwipeClose?: () => void;
};

const SidebarItemCollapse = ({
  item,

  open,
  handleDrawerSwipeClose,
}: Props) => {
  const [menuList, setMenuList] = useState<any>([]);
  const [openCallps, setOpenCallps] = useState(false);
  const { palette, themeMode } = useAppSelector(
    (state: any) => state.themeSlice
  );
  const { userData } = useAppSelector((state: any) => state.authReducer);

  useEffect(() => {
    let menus: any = [];
    item.subMenu.map((menu: any) => {
      if (
        (JSON.parse(userData.permission !== null ? userData.permission : "[]").includes(menu.menuId) && !["32", "31"].includes(menu.menuId)) ||
        userData.group == "admin"
      )
        menus.push(menu);
      return menu;
    });
    setMenuList(menus);
  }, [userData]);

  return (
    <>
      <ListItem
        key={item.to}
        disablePadding
        sx={{
          display: "block",
          borderRadius: "0px 25px 25px 0px",
          background:
            item.to === window.location.pathname ||
              (item.to === "/dashboard" &&
                window.location.pathname === "/" &&
                userData.group !== "admin") ||
              (item.to === "/ops-dashboard" && window.location.pathname === "/")
              ? palette.primary
              : "",
          // height: "40px",
        }}
      >
        <ListItemButton
          disableRipple
          onClick={() => setOpenCallps(!openCallps)}
          sx={{
            minHeight: 40,
            // borderRadius: "25px 25px 25px 25px",
            justifyContent: open ? "initial" : "center",
            p: 0,
            pl: open ? '14px' : '0px',
          }}
        >
          {open && <ListItemText
            primary={item.label}
            sx={{
              whiteSpace: 'normal',
              textDecoration: "none",
              opacity: open ? 1 : 0,
              color:
                item.to === window.location.pathname ||
                  (item.to === "/dashboard" &&
                    window.location.pathname === "/" &&
                    userData.group !== "admin") ||
                  (item.to === "/ops-dashboard" &&
                    window.location.pathname === "/")
                  ? "#fff"
                  : themeMode === "dark"
                    ? "#fff"
                    : "#4e4e4e",
            }}
            primaryTypographyProps={{
              fontSize:"13px",
              fontFamily: "'Plus Jakarta Sans', sans-serif", // Ensure it applies
            }}
          />}
          <ListItemIcon
            sx={{
              minWidth: 0,
              display: 'flex',
              mr: open ? 1 : "0px",
              justifyContent: "center",
              color:
                item.to === window.location.pathname ||
                  (item.to === "/dashboard" &&
                    window.location.pathname === "/" &&
                    userData.group !== "admin") ||
                  (item.to === "/ops-dashboard" &&
                    window.location.pathname === "/")
                  ? "#fff"
                  : themeMode === "dark"
                    ? "#fff"
                    : "",
            }}
          >
            {openCallps ? item.iconClosed : item.iconOpened}
          </ListItemIcon>
        </ListItemButton>
      </ListItem>
      <Collapse in={openCallps} timeout="auto">
        <List sx={{ ml: open ? 1 : "" , paddingTop:0, paddingBottom:0 }}>
          {menuList.map((row: any, index: number) =>
            row.subMenu != undefined && row.subMenu.length > 0 ? (
              <SidebarItemCollapse
                item={row}
                index={index}
                key={index}
                open={open}
              />
            ) : (
              <SidebarItem
                key={row.to}
                item={row}
                index={index}
                open={open}
                handleDrawerSwipeClose={handleDrawerSwipeClose}
              />
            )
          )}
        </List>
      </Collapse>
    </>
  );
};

export default SidebarItemCollapse;
